module.exports = __webpack_public_path__ + "img/intro-2.b4ec2dfd.png";